import React from 'react';
import { Card } from "react-bootstrap";
import face_balazs_varga from "../../assets/img/face_balazs_varga.jpg";
import ShowMoreText from "react-show-more-text";
import proj_design_of_exp_for_traffic_sim from "../../assets/img/proj_design_of_exp_for_traffic_sim.png";

const Balazs_Varga_design_of_exp = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_design_of_exp_for_traffic_sim} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_balazs_varga}
              /* ez a szöveg lesz majd a banneren */
              alt="Design of experiments for traffic simulation"
            />{" "}
            <p className="text7">Balázs Varga</p>
            <br />
            <p className="text8">
              Research Fellow{" "}
            </p>
            <p className="text8">BME Traffic Lab </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Design of experiments (DOE) deals with how to conduct experiments efficiently 
            under some resource constraints (e.g., cost, time). Simulators can also be 
            thought as domains where experiments are carried out which can be time consuming 
            when repeated too many times. Large-scale traffic simulations can have many 
            parameters (e.g., traffic volume, route choices, modal split etc.) that influence 
            the network performance (e.g., throughput, emissions).
            <br />
            <br />
            The goal of this research is to sequentially perform experiments to efficiently 
            map the parameter space without doing a full factorial design (simulating every 
            permutation) in traffic simulation. For that, a regression model shall be fitted 
            on the simulation outputs, sequentially minimizing model uncertainty. The expected 
            outcome is some uncertainty bound on the simulation sensitivity.
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                Robbins, H., 1952. Some aspects of the sequential design of experiments.
                </li>
                <li>
                Lopez, P.A., Behrisch, M., Bieker-Walz, L., Erdmann, J., Flötteröd, Y.P., 
                Hilbrich, R., Lücken, L., Rummel, J., Wagner, P. and Wießner, E., 
                2018, November. Microscopic traffic simulation using sumo. In 2018 21st 
                international conference on intelligent transportation systems (ITSC) (pp. 2575-2582). IEEE.
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balazs_Varga_design_of_exp;